import React, { useState, useEffect } from "react";
import InputGeneric from "../../../../../../components/Inputs/InputGeneric";
import SelectGeneric from "../../../../../../components/Inputs/SelectGeneric";
import {
  formCreditCard,
  optionAno,
  optionCI,
  optionMes,
  optionPhone,
  optionPymentAllBancos,
  optionPymentType,
  optionRIF,
} from "../../../../../../propsType/Payemnts";
import { useForm } from "../../../../../../Hooks/UseForm";
import bill from "../../../../../../assets/png/bill.png";
import credicard from "../../../../../../assets/bancos/credicard.png";
import ButtonGeneric from "../../../../../../components/Buttons/ButtonGeneric";
import { validateCredicard } from "../../../../../../validations/formValidations";
import PagosController from "../../../../../../controllers/PagosController";
import { optionDoc } from "../../../../../../propsType/SignIn";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { UseContextApp } from "../../../../../../Global/Context/appContext";
import { InformationCircleIcon } from "@heroicons/react/outline";
import Modal from "../../../../../../components/Modals/Modal";
import bancaribeBanner from "../../../../../../assets/Bancaribe.png";
import mibancoBanner from "../../../../../../assets/mibanco.png";
import Spinner from "../../../../../../components/Loading/loadingSpinner/Spinner";
import moment from "moment";
let interval;
function Bancos({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {

  const [{ user }] = UseContextApp();
  const [validarToken, setValidarToken] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [actPass, setActPass] = useState(false);
  const { form, errors, setForm, setErrors, handleChange, handleSubmit, handleBlur } = useForm(
    formCreditCard,
    validateCredicard,
    validarToken,
    activeButton
  );
  const { pagoCreditCard, tokenCreditCard } = PagosController();
  const [client, setClient] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [showCvc, setShowCvc] = useState(false);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgBanner, setImgBanner] = useState("");
  const [message, setMessage] = useState("");
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));
  const [showNroTDC, setShowNroTDC] = useState(false);
  const [time, setTime] = useState(580)
  const handleStart = () => {
    setTime(580);
    setTime((time) => (time > 0 ? time - 1 : 580));
     interval = setInterval(() => {
      setTime((time) => (time > 0 ? time - 1 : 580));
    }, 1000);
  };
  const handleStop = () => { setTime(580); clearInterval(interval)}
  const funtionShowNroTDC = () => { setShowNroTDC(!showNroTDC); };
  const funtionShowCvc = () => { setShowCvc(!showCvc); };
  const funtionShowPink = () => { setShowPin(!showPin); };
  const handle = (e) => {
    setClient(e);

  };
  const getToken = async () => {
    if (activeButton) {
      setErrors("");
      setActiveButton(false);
      setForm({
        ...form,
        selectDoc: "",
        typeDoc: "",
        numberCardCredicard: "",
        name: "",
        typeAccount: "",
        month: "",
        year: "",
        cvc: "",
        pinCard: "",
        selectNumber: "",
        phone: "",
        token: ""
        
      });
      setActPass(false);
    }
    else {
      const result = handleSubmit();
      if (result === "ok") {
        if (bankInfo.banco.title === "Bancaribe" || bankInfo.banco.title === "R4 Banco Microfinanciero") {
          handleStart();
          
          setValidarToken(true);
          setActiveButton(true);
          setActPass(true);
          if (bankInfo.banco.title === "Bancaribe") {
            setModal(true);
            setImgBanner(bancaribeBanner);
            setMessage("");
          }
          if (bankInfo.banco.title === "R4 Banco Microfinanciero") {
            setModal(false);
            setImgBanner(mibancoBanner);
            setMessage("");
          }
        }
        else {
          setActiveButton(true);
          setActPass(true);
          setValidarToken(true);
          handleStart();
          const result = handleSubmit();
          if (result === "ok" && client) {
            let newObjet =
            {
              nroTarjeta: form.numberCardCredicard,
              rif: form.selectDoc + form.typeDoc,
            };
            const res = await tokenCreditCard(newObjet);
            switch (res.respuesta) {
              case "0":
                setModal(true);
                setMessage(res.descripcion);
                setValidarToken(true);
                setActiveButton(true);
                setActPass(true);
                break;
              default:
                setModal(true);
                setMessage("Hemos presentado inconvenientes de comunicación con el banco. Por favor, intenta nuevamente más tarde.");
                setActiveButton(false);
                setActPass(false);
                break;
            }
          }
        }
      }
    }
  };
  
  function filtro(e) {
    if (form.selectDoc !== "P"){
      var tecla = e.key;
      if (['.', 'e','E' ].includes(tecla))
        e.preventDefault()}
  }

  const pagar = async () => {
    setImgBanner("");
    let ano = form.year.slice(form.year.length - 2);
    const result = handleSubmit();
    if (result === "ok") {
      setLoading(true);

      let newObjet = {
        cuenta: deatils.nroCuenta,
        nombreCliente: user.datos.nombreApellido,
        monto: data.metodoAPagar,
        nroTarjeta: form.numberCardCredicard,
        mesExp: form.month,
        anoExp: ano,
        nombreTitular: form.name,
        docType: client.name,
        rif: form.selectDoc + form.typeDoc,
        tipoTarjeta: "Débito",
        tipoCuenta: form.typeAccount,
        tlf: form.selectNumber + form.phone,
        pin: form.pinCard,
        cvc: form.cvc,
        token: form.token,
        transaccion: Math.round(Math.random() * 10000000000),
      };
   

      const res = await pagoCreditCard(newObjet);

      
      switch (res.respuesta) {
        case "0":
          setData({ ...data, transaccion: newObjet.transaccion, monto: newObjet.monto, fecha: fechaNow });
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          }); setActiveButton(true);
          break;
        default:
          setMessage("Hemos presentado inconvenientes al procesar tu pago. Por favor, intenta nuevamente más tarde.");
          setLoading(false);
          setModal(true);
          setActiveButton(false);
          handleStop();
          setForm({
            ...form,
            selectDoc: "",
            typeDoc: "",
            numberCardCredicard: "",
            name: "",
            typeAccount: "",
            month: "",
            year: "",
            cvc: "",
            pinCard: "",
            selectNumber: "",
            phone: "",
            token: ""
          });
          setActPass(false);
          break;
      }
    }
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="flex lg:pt-[125px] pt-[220px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="lg:w-[70%]  ">
          {loading ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <Spinner title={"Solicitud en Proceso. Espere por favor..."} />
              </div>
            </>
          ) : (
            <>
              <div className="absolute left-0 top-0 w-full ">
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Pagar
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Completa la información y haz clic en pagar
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-full flex flex-col  justify-between lg:pr-[50px] ">
                <div className="grid lg:gap-[20px] gap-6 lg:relative lg:-top-[25px]">
                  <div className="flex justify-between flex-col md:flex-row  gap-6 items-center">
                    <div className="relative flex  w-full">
                      <RadioGroup
                        value={client}
                        onChange={(e) => handle(e)}
                        className="w-full"
                      >
                        <RadioGroup.Label className="text-sm font-medium text-gray-900">
                          {" "}
                          Seleccione el tipo de documento{" "}
                        </RadioGroup.Label>
                        <div className="mt-1 w-full grid grid-cols-1 lg:grid-cols-2 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                          {optionDoc.map((ban, index) => (
                            <RadioGroup.Option
                              key={index}
                              value={ban}
                              disabled={actPass}
                              className={({ checked, active }) =>
                                classNames(
                                  !client
                                    ? "border-red-500"
                                    : "border-gray-300",
                                  active ? "ring-2 ring-[#09101f] " : "",
                                  "relative bg-white border rounded-lg h-[40px] p-[9px] shadow-sm  flex cursor-pointer focus:outline-none"
                                )
                              }
                            >
                              {({ checked, active }) => (
                                <>
                                  <div className="flex-1 flex">
                                    <div className="flex h-[20px] w-full justify-center items-center ">
                                      <RadioGroup.Label
                                        as="span"
                                        className="block text-lg font-medium text-gray-900"
                                      >
                                        {ban.name}
                                      </RadioGroup.Label>
                                    </div>
                                  </div>
                                  {checked ? (
                                    <CheckCircleIcon
                                      className="h-5 w-5 text-[#09101f] "
                                      aria-hidden="true"
                                    />
                                  ) : null}
                                  <div
                                    className={classNames(
                                      active ? "border" : "border-2",
                                      checked
                                        ? "border-[#09101f] "
                                        : "border-transparent",
                                      "absolute -inset-px rounded-lg pointer-events-none"
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>

                    <div className="grid w-full ">
                      <div className="text-sm font-medium text-gray-900">
                        Documento de Identidad
                      </div>
                      <div className="grid !mt-1  grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.selectDoc}
                            name={"selectDoc"}
                            disabled={actPass}
                            onBlur={handleBlur}
                            errors={errors.selectDoc}
                            selectData={
                              client?.name === "CI" ? optionCI : optionRIF
                            }
                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "P" ? "text" : "number"}
                            onKeyDown={(e) => filtro(e)}
                            maxValue={13}
                            value={form.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors.typeDoc}
                            disable={actPass}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative flex gap-5  w-full">
                    <InputGeneric
                      title={"Número de Tarjeta"}
                      name={"numberCardCredicard"}
                      value={form.numberCardCredicard}
                      errorText={errors.numberCardCredicard}
                      onChange={handleChange}
                      handleBlur={handleBlur}
                      maxValue={19}
                      disable={actPass}
                      type={showNroTDC ? "text" : "password"}
                      show={showNroTDC}
                      funtionShow={funtionShowNroTDC}

                    />
                    <InputGeneric
                      textTopTips={"Nombre que aparece en la tarjeta"}
                      iconTop={true}
                      title={"Nombre del Titular"}
                      type={"text"}
                      name={"name"}
                      value={form.name}
                      onChange={handleChange}
                      errorText={errors.name}
                      handleBlur={handleBlur}
                      disable={actPass}

                    />
                  </div>
                  <div className="flex justify-between flex-col lg:flex-row gap-6 items-center">
                    <div className="grid w-full ">
                      <div className="text-sm font-medium text-gray-900">
                        Tipo de Cuenta
                      </div>
                      <div className="grid !mt-1 ">
                        <SelectGeneric
                          onChange={handleChange}
                          value={form.typeAccount}
                          name={"typeAccount"}
                          onBlur={handleBlur}
                          errors={errors.typeAccount}
                          selectData={optionPymentAllBancos}
                          disabled={actPass}

                        />
                      </div>
                    </div>
                    <div className="w-full h-full flex gap-5">
                      <div className="grid w-full ">
                        <div className="text-sm font-medium text-gray-900">
                        Mes de Vencimiento
                        </div>
                        <div className="grid !mt-1 ">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.month}
                            name={"month"}
                            onBlur={handleBlur}
                            errors={errors.month}
                            selectData={optionMes}
                            disabled={actPass}

                          />
                        </div>
                      </div>
                      <div className="grid w-full ">
                        <div className="text-sm font-medium text-gray-900">
                        Año de Vencimiento
                        </div>
                        <div className="grid !mt-1 ">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.year}
                            name={"year"}
                            onBlur={handleBlur}
                            errors={errors.year}
                            selectData={optionAno}
                            disabled={actPass}

                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between flex-col lg:flex-row gap-6 items-center">
                    <div className="w-full">
                      <InputGeneric
                        textTopTips={"Código de seguridad de la tarjeta"}
                        iconTop={true}
                        title={"Código de Seguridad (CVV)"}
                        type={showCvc ? "text" : "password"}
                        name={"cvc"}
                        value={form.cvc}
                        onChange={handleChange}
                        errorText={errors.cvc}
                        handleBlur={handleBlur}
                        show={showCvc}
                        funtionShow={funtionShowCvc}
                        maxValue={3}
                        disable={actPass}

                      />
                    </div>
                    <div className="w-full">
                      <InputGeneric
                        textTopTips={"Pin de la tarjeta"}
                        iconTop={true}
                        title={"Clave de la Tarjeta"}

                        name={"pinCard"}
                        value={form.pinCard}
                        onChange={handleChange}
                        errorText={errors.pinCard}
                        handleBlur={handleBlur}
                        type={showPin ? "text" : "password"}
                        show={showPin}
                        funtionShow={funtionShowPink}
                        disable={actPass}

                      />
                    </div>
                  </div>
                  <div className="flex justify-between flex-col lg:flex-row gap-6 items-center">
                    <div className="grid w-full ">
                      <div className="flex items-center gap-3  text-gray-900">
                        <p className="text-sm  font-medium  "> Nº Celular</p>
                        <p>
                          <div
                            className={` button cursor-pointer !w-[14px]`}
                            data-tooltip={"Número de teléfono del titular"}
                          >
                            <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                          </div>
                        </p>
                      </div>
                      <div className="grid !mt-1  grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.selectNumber || ""}
                            name={"selectNumber"}
                            onBlur={handleBlur}
                            errors={errors.selectNumber}
                            selectData={optionPhone}
                            disabled={actPass}

                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"phone"}
                            type={"number"}
                            value={form.phone}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors.phone}
                            disable={actPass}

                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid w-full">
                      <div className="grid !mt-1  grid-cols-7">
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between flex-col lg:flex-row gap-6 items-center">
                    <div className="relative flex w-full">
                      <InputGeneric
                        handleBlur={handleBlur}
                        type={"number"}
                        title={"Token"}
                        name={"token"}
                        value={form.token}
                        onChange={handleChange}
                        errorText={errors.token}
                        maxValue={8}
                        disable={!activeButton}
                      />
                    </div>
                    <div className="col-span-5 flex h-full items-end w-full">
                      <button
                        type="button" disabled={activeButton}
                        onClick={() => getToken()}
                        className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
                      >
                        {activeButton ? "Solicitar" : "Solicitar"}
                      </button>
                      <p className="inline-flex w-full justify-center rounded-md bg-[#09101F] px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto">
                        {time} segundos
                      </p>
                    </div>
                  </div>
                  <div className="">
                  </div>
                  <div className="w-full flex justify-center items-center gap-4">
                    <div>Procesado por</div>
                    <img className="w-[110px]" src={credicard} alt="" />
                  </div>
                  <p className="text-[0.8rem] text-[#798791]">
                    {" "}
                    Importante: Por favor verifique que los datos suministrados sean exactos, para que su transacción sea exitosa.
                  </p>
                  <div>
                    <hr className="pt-[10px] mt-[10px]" />

                  </div>
                </div>
                <div className="w-full mt-5 flex justify-between items-center gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric funtion={pagar} text={"Pagar"} disable={!activeButton} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   
                            before:content-[''] 
                            before:absolute 
                            before:w-[45px] 
                            before:h-[45px] 
                            before:rounded-full 
                            before:bg-white 
                            before:bottom-[-20px]
                            before:left-[-20px]
                            after:content-[''] 
                            after:absolute 
                            after:w-[45px] 
                            after:h-[45px] 
                            after:rounded-full 
                            after:bg-white 
                            after:bottom-[-20px]
                            after:right-[-20px] 
            "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-25%] z-[10] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[90%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={bankInfo?.banco?.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {data.metodoPago.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>{" "}
                <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>
          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div className="text-[#798791] ">Monto a Pagar</div>
                <div className="text-2xl font-medium">
                  <span className="text-[#798791] pr-2 ">Bs</span>
                  {data?.metodoAPagar}
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bill} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        message={message ? message : "Te comparto la información para solicitar el Token"}
        active={modal}
        setActive={setModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <div>
              <img src={imgBanner} alt="" />
            </div>
            <button
              type="button"
              onClick={() => setModal(false)}
              className="inline-flex w-full justify-center rounded-md bg-[#09101F] px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Bancos;
